import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "@aman/design-system/styles.css";
import "./app.css";
import "./i18n";
import { App } from "./App";
import { AuthProvider } from "./auth/AuthContext";

const root = document.getElementById("root");
if (root === null) throw new Error("Application root element is missing");
ReactDOM.createRoot(root).render(<React.StrictMode><BrowserRouter><AuthProvider><App /></AuthProvider></BrowserRouter></React.StrictMode>);
